document.addEventListener('DOMContentLoaded', function () {
  const nav = document.getElementById('mainNav');

  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('compact', window.scrollY > 60);
    });
  }

  const burger = document.getElementById('burger');
  const mobileNav = document.getElementById('mobNav');

  window.closeMob = function () {
    if (burger) burger.classList.remove('open');
    if (mobileNav) mobileNav.classList.remove('open');
    document.body.style.overflow = '';
  };

  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      burger.classList.toggle('open');
      mobileNav.classList.toggle('open');
      document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
    });
  }

  const revealItems = document.querySelectorAll('.reveal');

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('vis');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    revealItems.forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    revealItems.forEach(function (el) {
      el.classList.add('vis');
    });
  }

  const counters = document.querySelectorAll('.pn[data-t]');

  if ('IntersectionObserver' in window) {
    const counterObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const el = entry.target;
            const target = Number(el.dataset.t || 0);
            const suffix = el.dataset.s || '';
            let count = 0;
            const step = Math.max(1, Math.ceil(target / 50));

            const interval = setInterval(function () {
              count += step;

              if (count >= target) {
                count = target;
                clearInterval(interval);
              }

              el.textContent = count.toLocaleString() + suffix;
            }, 22);

            counterObserver.unobserve(el);
          }
        });
      },
      { threshold: 0.4 }
    );

    counters.forEach(function (el) {
      counterObserver.observe(el);
    });
  }

  document.querySelectorAll('.faq-item').forEach(function (item) {
    const question = item.querySelector('.faq-q');

    if (!question) return;

    question.addEventListener('click', function () {
      const wasOpen = item.classList.contains('open');

      document.querySelectorAll('.faq-item').forEach(function (faq) {
        faq.classList.remove('open');

        const faqQuestion = faq.querySelector('.faq-q');
        if (faqQuestion) faqQuestion.setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        item.classList.add('open');
        question.setAttribute('aria-expanded', 'true');
      }
    });
  });
});